import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";
import { Button } from "react-bootstrap";
import ReactTable from "react-table";
import AccountingExportHeader from "./accounting-export-header";
import Spinner from "../../../common/Spinner";
import {
    exportAccountingActiveJobs,
    exportAccountingClientInvoices,
    fetchAccountingClientInvoices,
    exportAccountingClientReportExcel
} from "../../../../api/menu/invoicing/actions";
import filterCaseInsensitive from "../../../custom/forms/react-table-case-insensitive";
import CustomCheckbox from "../../../custom/forms/custom-checkbox";
import { closeCustomModal, openCustomModal } from "../../../custom/modals";

class ClientInvoicesList extends React.Component {
    dateFormat = "YYYY-MM-DD";

    constructor(props) {
        super(props);

        this.state = {
            batchNumber: 0,
            selectedClientInvoices: []
        };

        this.handleLoadClientInvoices = this.handleLoadClientInvoices.bind(this);
        this.handleExportClientInvoices = this.handleExportClientInvoices.bind(this);
        this.setBatchNumber = this.setBatchNumber.bind(this);
        this.setSelectedClientInvoices = this.setSelectedClientInvoices.bind(this);
        this.handleBatchReport = this.handleBatchReport.bind(this);
    }

    componentDidMount() {
        this.handleLoadClientInvoices();
    }

    handleLoadClientInvoices() {
        this.props.fetchAccountingClientInvoices(this.state.batchNumber);
    }

    handleExportClientInvoices() {
        const { selectedClientInvoices } = this.state;

        const requestBody = {
            invoiceIds: selectedClientInvoices,
        };
        this.props.exportAccountingClientInvoices(requestBody, this.handleLoadClientInvoices);
    }

    setBatchNumber(batch) {
        this.setState({
            batchNumber: batch.value
        });
    }

    setSelectedClientInvoices(id) {
        const selectedInvoices = Object.assign([], this.state.selectedClientInvoices);

        const index = selectedInvoices.indexOf(id);

        if (index >= 0) {
            selectedInvoices.splice(index, 1);
        } else {
            selectedInvoices.push(id);
        }

        this.setState({
            selectedClientInvoices: selectedInvoices
        });
    }

    handleBatchReport() {
        const { batchNumber } = this.state;

        this.props.exportAccountingClientReportExcel(batchNumber);
    }

    onToggle = () => {
        const { selectedClientInvoices } = this.state;
        const { accountingExportClientInvoices } = this.props;

        const selectedInvoices =
            selectedClientInvoices.length === accountingExportClientInvoices.length ?
                [] : accountingExportClientInvoices.map(i => i.invoiceId);

        this.setState({
            selectedClientInvoices: selectedInvoices
        });
    };

    getColumns = () => {
        const { selectedClientInvoices } = this.state;
        const { accountingExportClientInvoices } = this.props;

        const columns = [];

        columns.push({
            Cell: ({ original }) => (
                <CustomCheckbox
                    key={original.invoiceId}
                    className="checkbox"
                    checked={selectedClientInvoices.includes(original.invoiceId)}
                    onChange={() => this.setSelectedClientInvoices(original.invoiceId)}
                />
            ),
            headerClassName: "text-left",
            Header: () => (
                <input
                    type="checkbox"
                    className="checkbox"
                    checked={selectedClientInvoices.length ? selectedClientInvoices.length ===
                        accountingExportClientInvoices.length : false}
                    onChange={() => this.onToggle()}
                />
            ),
            sortable: false,
            filterable: false,
            resizable: false,
            minResizeWidth: 40,
            width: 40,
            className: "d-flex"
        });
        columns.push({
            Header: "Invoice Number",
            headerClassName: "text-left",
            accessor: "invoiceNum"
        });
        columns.push({
            id: "date",
            Header: "Date",
            headerClassName: "text-left",
            accessor: original => moment(original.invoiceDate)
                .format(this.dateFormat)
        });
        columns.push({
            Header: "Client",
            headerClassName: "text-left",
            accessor: "clientName"
        });
        columns.push({
            Header: "Amount",
            headerClassName: "text-left",
            accessor: "total"
        });
        columns.push({
            Header: "Batch Number",
            headerClassName: "text-left",
            accessor: "batchNum"
        });

        return columns;
    };

    render() {
        const {
            selectedClientInvoices,
            batchNumber
        } = this.state;
        const { accountingExportClientInvoices } = this.props;

        const selectedText = accountingExportClientInvoices.length ?
            `Selected ${selectedClientInvoices.length} out of ${accountingExportClientInvoices.length} invoices` : "";

        return (
            <div className="dashboard">
                <div className="position-relative">
                    {!this.props.loading || <Spinner/>}

                    <AccountingExportHeader
                        handleLoad={this.handleLoadClientInvoices}
                        batchNumber={batchNumber}
                        batches={this.props.batches}
                        setBatchNumber={this.setBatchNumber}
                        selectedText={selectedText}
                    />
                    <div className="mb-4">
                        <ReactTable
                            data={accountingExportClientInvoices}
                            columns={this.getColumns()}
                            headerClassName="table-header"
                            showPagination={false}
                            pageSize={Math.max(accountingExportClientInvoices.length, 20)}
                            resizable
                            className="-striped -highlight"
                            filterable={false}
                            defaultFilterMethod={filterCaseInsensitive}
                            getNoDataProps={() => ({
                                style: {
                                    zIndex: 0
                                }
                            })}
                            style={{
                                height: "calc(100vh - 270px)",
                            }}
                        />
                    </div>
                </div>
                <div className="mt-4 mb-4 text-left">
                    <Button
                        id="export-client"
                        disabled={!selectedClientInvoices.length}
                        variant="primary"
                        onClick={this.handleExportClientInvoices}
                    >
                        Export Selection
                    </Button>
                    <Button
                        className="ml-2"
                        variant="success"
                        onClick={this.handleBatchReport}
                    >
                        Batch Report
                    </Button>


                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.invoicing.loading,

    accountingExportClientInvoices: state.invoicing.accountingExportClientInvoices,
    exportedData: state.invoicing.exportedData
});

const mapStateToDispatch = dispatch => ({
    fetchAccountingClientInvoices: bindActionCreators(fetchAccountingClientInvoices, dispatch),
    exportAccountingClientInvoices: bindActionCreators(exportAccountingClientInvoices, dispatch),
    exportAccountingActiveJobs: bindActionCreators(exportAccountingActiveJobs, dispatch),
    exportAccountingClientReportExcel: bindActionCreators(exportAccountingClientReportExcel, dispatch),

    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch)
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(ClientInvoicesList);
